import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { useQuery } from "@tanstack/react-query";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

import { LabelValue } from "../../../../../components/LabelValue/LabelValue";
import { requests } from "../../../../../services/http-common";

import styles from "./CreateContractModal.module.scss";
import { ILeadDetails } from "../../../SalesLead/Lead.model";

enum AvailableForContractCreation {
  Available = "AVAILABLE",
  Unavailable = "UNAVAILABLE",
}

interface CreateContractModalProps {
  show: boolean;
  set: (state: boolean) => void;
}

export function CreateContractModal({
  show,
  set,
}: CreateContractModalProps): JSX.Element | null {
  const navigate = useNavigate();
  const [selectedLead, setSelectedLead] = useState<{
    name: string;
    leadId: string;
  }>();

  const { data, isLoading } = useQuery({
    queryKey: [`lead-list`],
    queryFn: () => {
      return requests.get(
        `/lead?availableForContractCreation=${AvailableForContractCreation.Available}`
      );
    },
    retry: false,
    cacheTime: 0,
  });

  const handleSelectClick = () => {
    navigate(`/sales/contract/create/${selectedLead?.leadId}`);
  };

  return (
    <Dialog
      visible={show}
      onHide={() => set(false)}
      resizable={false}
      draggable={false}
      header="Choose a Lead"
      modal
      style={{ width: 632 }}
    >
      <LabelValue label="Leads" bold>
        <Dropdown
          disabled={isLoading}
          placeholder="Select Lead"
          options={data?.result.map(
            ({
              companyName,
              contactName,
              address,
              name,
              surname,
              id,
            }: ILeadDetails) => ({
              name: companyName
                ? `${contactName} | ${address}`
                : `${name} ${surname} | ${address}`,
              leadId: id,
            })
          )}
          style={{ width: 472 }}
          optionLabel="name"
          onChange={(e) => {
            setSelectedLead(e.value);
          }}
          value={selectedLead}
        />
      </LabelValue>
      <div className={styles.buttons}>
        <Button
          label="Cancel"
          className="p-button-text"
          onClick={() => set(false)}
        />
        <Button
          label="Select"
          className="p-button-m"
          type="button"
          disabled={!selectedLead}
          onClick={handleSelectClick}
        />
      </div>
    </Dialog>
  );
}
